module.exports = __webpack_public_path__ + "img/service4.bb7a640.svg";